

export const environment = {
  production: false,
  
   API_URL: "https://api.buddhaword.app/api/v1/", 
   
};
